import { axios } from 'services/axios';

/**
 * Returns the licences for an existing EightByEight service.
 *
 * GET /Service/EightByEight/{serviceID}/Licenses
 *
 * @param {string} serviceID
 * @returns {Promise<Array>} licences, e.g.
 *   { catalogItemID, name, description, allowedQuantity, usedQuantity }
 *   - allowedQuantity = Volume (entitlement limit)
 *   - usedQuantity    = Active (currently in use)
 */
const getEightByEightServiceLicenses = async (serviceID) => {
    if (!serviceID) return [];
    const res = await axios.get(`/Service/EightByEight/${serviceID}/Licenses`);
    return Array.isArray(res.data) ? res.data : [];
};

export default getEightByEightServiceLicenses;
